import { useSelector } from "react-redux"
import { RootState } from "../../../store/Store"

export default function useAuthenticated() {
    return useSelector((state: RootState) => state.authentication.access_token !== undefined)
}
